import { useState } from "react";
import { MapPin, Phone, Mail, Clock, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Analytics } from "@/lib/analyticsShim";

const RAILAXIS_LOGO_SRC = `${process.env.PUBLIC_URL || ""}/assets/Logo/Railaxis_logo.png`;

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("Subscribed! Watch your inbox for updates.");
      setEmail("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Subscribe failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="bg-[#111827] text-white pt-16 pb-8 px-6 md:px-10" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 pb-12 border-b border-white/10">
          {/* Contact */}
          <div>
            <div className="flex items-center gap-2 mb-6">
              <img
                src={RAILAXIS_LOGO_SRC}
                alt="RailAxis logo"
                className="w-9 h-9 rounded-md object-contain bg-white"
              />
              <div className="font-display font-bold text-xl">
                Rail<span className="text-[#C8A96A]">Axis</span>
              </div>
            </div>
            <h3 className="font-display font-semibold text-lg mb-6 text-white">Reach Us</h3>
            <ul className="space-y-4 text-sm text-white/80">
             <li className="flex gap-3">
                <MapPin className="w-5 h-5 text-[#C8A96A] shrink-0" />
                <a
                  href="https://maps.google.com/?q=No.33,1st Floor 1st Main,Ganganagar Gramatana,R T Nagar,Bangalore North,Bangalore 560032"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#C8A96A] transition-colors"
                >
                  No.33, 1st Floor 1st Main, Ganganagar Gramatana, R T Nagar, Bangalore North
                  <br />
                  Bangalore - 560032.
                </a>
              </li>
             <li className="flex gap-3">
                    <Phone className="w-5 h-5 text-[#C8A96A] shrink-0" />
                    <a
                      href="tel:+919032893433"
                      className="hover:text-[#C8A96A] transition-colors"
                    >
                      +91 9032893433
                    </a>
                  </li>

                  <li className="flex gap-3">
                    <Mail className="w-5 h-5 text-[#C8A96A] shrink-0" />
                    <a
                      href="mailto:railaxis.off@gmail.com"
                      className="hover:text-[#C8A96A] transition-colors"
                    >
                      railaxis.off@gmail.com
                    </a>
                  </li>
              <li className="flex gap-3">
                <Clock className="w-5 h-5 text-[#C8A96A] shrink-0" />
                <span>Mon – Sat · 9:00 AM to 7:00 PM IST</span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="font-display font-semibold text-2xl md:text-3xl mb-3 text-white">Stay Up to Date</h3>
            <p className="text-sm text-white/70 mb-6 max-w-md">
              Get the latest news, market prices & project highlights delivered to your inbox every week.
            </p>
            <form onSubmit={subscribe} className="flex gap-2 max-w-md" data-testid="newsletter-form">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your business email"
                className="flex-1 bg-white/5 border border-white/15 rounded-md px-4 py-3 text-sm text-white placeholder:text-white/40 gold-focus"
                data-testid="newsletter-email-input"
              />
              <button
                type="submit"
                disabled={submitting}
                className="btn-gold rounded-md px-5 py-3 text-sm font-semibold disabled:opacity-60 flex items-center gap-2"
                data-testid="newsletter-subscribe-btn"
              >
                {submitting && <Loader2 className="w-4 h-4 animate-spin" />}
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="flex justify-between items-center pt-8 flex-wrap gap-4">
          <p className="text-sm text-white/50">© 2026 RailAxis. All rights reserved.</p>
          <p className="text-sm text-white/50">Made for India's infrastructure builders.</p>
        </div>
      </div>
    </footer>
  );
}
